import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { ParkbewilligungenData, PbKategorieTyp } from '../parkbewilligungen-data';
import { UserData } from '../../../providers/user-data';
import { Components } from "../../../components";
/**
 * Generated class for the PbactionsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pbkategorieselection',
  templateUrl: 'pbkategorieselection.html',
})
export class PbKategorieSelection  implements OnInit {
  public searchQuery : string = "";
  
  constructor(public navCtrl: NavController

            , public pbData: ParkbewilligungenData
            , private _viewController: ViewController
            , private userData: UserData
    ) 
  {

  }

  ionViewDidLoad() {
    
  }
  ngOnInit(){
    this.pbData.selectedKategorie = null;
  }
  selectKategorie(pbkat){
    this.pbData.selectedKategorie = pbkat;
    this._viewController.dismiss(pbkat);
  }

}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/pbkategorieselection/pbkategorieselection.ts